import React from 'react';

import BoldCheckIcon from '@ott/icon-bold-check';
import BoldCrossIcon from '@ott/icon-bold-cross';

import { MessageConfig } from './types';

export enum MessageTypes {
  Success = 'success',
  Error = 'error',
}

export const DEFAULT_DURATION = 4000;

export const PREDEFINED_CONFIGS: Record<MessageTypes, MessageConfig> = {
  [MessageTypes.Success]: {
    type: MessageTypes.Success,
    icon: <BoldCheckIcon />,
  },
  [MessageTypes.Error]: {
    type: MessageTypes.Error,
    icon: <BoldCrossIcon />,
  },
};
